import type { IconNode } from '../types';

/**
 * @name hot-dog
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcuMSAzLjVhNCA0IDAgMCAwLTUuOS0uM2wtOCA4YTQgNCAwIDAgMCAuMiA1LjkiIC8+CiAgPHBhdGggZD0iTTYuOSAyMC43YTQuMDcgNC4wNyAwIDAgMCA1LjkuMWw4LThhNCA0IDAgMCAwLS4xLTUuOSIgLz4KICA8cGF0aCBkPSJNMjEuMyA2LjNhMi41IDIuNSAwIDAgMC0zLjUtMy41bC0xNSAxNWEyLjUgMi41IDAgMCAwIDMuNSAzLjVaIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/hot-dog
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hotDog: IconNode = [
  ['path', { d: 'M17.1 3.5a4 4 0 0 0-5.9-.3l-8 8a4 4 0 0 0 .2 5.9', key: '1yxrxa' }],
  ['path', { d: 'M6.9 20.7a4.07 4.07 0 0 0 5.9.1l8-8a4 4 0 0 0-.1-5.9', key: 't982x8' }],
  ['path', { d: 'M21.3 6.3a2.5 2.5 0 0 0-3.5-3.5l-15 15a2.5 2.5 0 0 0 3.5 3.5Z', key: 'rhan5l' }],
];

export default hotDog;
